import axios from '@/axios.js'
// import authorizedAxios from '@/http/axios/index.js'

export default {
  fetchMaps ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // axios.get('/get-geo-json', { params: {filter: payload.filter} })
      axios.get('/get-geo-json')
        .then((response) => {
            commit('SET_MAPS', response.data.data)
            // commit('ADD_SELECTED_MAP', response.data.data.features[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  searchMap ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if(payload.search_word){
        const  searchedVillage = payload.village_data.filter(function (item) {
          return item.name === payload.search_word
        })
        const searchedMap = payload.geoJson.features.filter(function (item) {
          return item.properties.village_id === searchedVillage[0].id
        })

        if(searchedMap.length < 1){
          resolve('No Data')
        }

        commit('ADD_SEARCHED_MAPS', searchedMap)
        if(searchedVillage[0].name !== searchedMap[0].properties.name){
          commit('ADD_VILLAGE_NAME', searchedVillage[0].name)
        }

        if(searchedVillage[0].subdistrict_id === 1){
          commit('ADD_SUB_DISTRICT_NAME', 'บ้านโฮ่ง')
        }else if(searchedVillage[0].subdistrict_id === 2){
          commit('ADD_SUB_DISTRICT_NAME', 'ป่าหลู')
        }else if(searchedVillage[0].subdistrict_id === 3){
          commit('ADD_SUB_DISTRICT_NAME', 'เหล่ายาว')
        }else if(searchedVillage[0].subdistrict_id === 4){
          commit('ADD_SUB_DISTRICT_NAME', 'ศรีเตี้ย')
        }else if(searchedVillage[0].subdistrict_id === 5){
          commit('ADD_SUB_DISTRICT_NAME', 'หนองปลาสะวาย')
        }
      }else{
        const searchedMap = null
        commit('ADD_SEARCHED_MAPS', searchedMap)
      }
    })
  },
  filterMap ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/get-geo-json', { params: {date_filter: payload.date_filter , time_filter: payload.time_filter} })
        .then((response) => {
          if (response.data.data.features === null){
            resolve('No Data')
          }else{
            commit('SET_MAPS', response.data.data)
          }
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getSelectedMapAQIDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/get-aqi`, { params: {village_id: Object.values(payload)[0]} })
        .then((response) => {
          commit('ADD_AQI_DETAIL', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTest () {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-user')
        .then((response) => {
          console.log(response)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
